// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"3895c379","193":"600f8b0f","344":"58f0c4b3","455":"033a5c94","492":"04a95c1c","587":"2e1b40db","640":"2ccc5ebe","695":"a73cd6b3","727":"14bb475b","977":"0a6b4bdf"}[chunkId] + ".chunk.js";
};